// API Base URL Configuration
export const API_BASE_URL = 'https://vinayagagoldapi.tieupsolutions.com';

// Helper function to build full API URLs
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

// Common API endpoints
export const API_ENDPOINTS = {
  // Loan endpoints
  LOAN_SEARCH: '/api/Loan',
  LOAN_DELETE: (id) => `/api/Loan/DeleteLoanByID/${id}`,
  LOAN_GET_BY_ID: (id) => `/api/Loan/GetLoanByID/${id}`,
  LOAN_PAYMENT_SAVE: '/api/Loan/SaveLoanPayment',
  LOAN_PAYMENT_HISTORY: (loanId) => `/api/Loan/GetAllLoanPaymentByLoanID/${loanId}`,
  LOAN_INTEREST_DETAILS: (loanId) => `/api/Loan/GetLoanInterestByLoanID/${loanId}`,
  LOAN_PAYMENT_SUMMARY: (loanId) => `/api/Loan/GetLoanPaymentSummary/${loanId}`,
  LOAN_SAVE: '/api/Loan',
  LOAN_SAVE_INTEREST: '/api/Loan/SaveLoanInterest',
  
  // Gold endpoints
  GOLD_GET_BY_LOAN_ID: (loanId) => `/api/Loan/GetGoldInfoByLoanID/${loanId}`,
  GOLD_DELETE: (goldId) => `/api/Loan/DeleteGoldInfoByGoldInfoID/${goldId}`,
  GOLD_SAVE: '/api/Loan/SaveGoldInfo',
  
  // Report endpoints
  MONTHLY_REPORT: '/api/Loan/GetMonthlyReport',
  LOAN_SUMMARY: '/api/Loan/GetLoanSummary',
  
  // Auth endpoints
  LOGIN: '/api/Login/Login',
  
  // Subscription endpoints
  SUBSCRIPTION_CHECK: '/api/Subscription/IsSubscriptionActive',
  
  // Master endpoints
  DOMAIN_VALUES: '/api/Master/DomainValue',
}; 